import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    //Main

    {
      path: '/login',
      component: () => import('@/components/Login')
    },
    //Admin Tools
    // {
    //   path: '/admin_tools/change_roles',
    //   component: () => import('@/components/AdminTools/ChangeRoles')
    // },
    // {
    //   path: '/admin/register_user',
    //   component: () => import('@/components/AdminTools/RegisterUser')
    // },
    {
      path: '/orders/list',
      component: () => import('@/components/Orders/OrderList')
    },
    {
      path: '/orders/create',
      component: () => import('@/components/Orders/CreateOrder')
    },
    {
      path: '/clients/list',
      component: () => import('@/components/Clients/ClientsList')
    },
    {
      path: '/test',
      component: () => import('@/components/Test')
    },
    // {
    //   path: '/admin_tools/change_password',
    //   component: () => import('@/components/AdminTools/ChangePassword')
    // },
    //Notifications
    {
      path: '/products/list',
      component: () => import('@/components/Lists/Products/List')
    },
    {
      path: '/users/list',
      component: () => import('@/components/Lists/Users/List')
    },
    {
      path: '/reports/CouriersDailyReports',
      component: () => import('@/components/Reports/CouriersDailyReports')
    },
    {
      path: '/notification/notifications',
      component: () => import('@/components/Notifications/Notifications')
    },
    {
      path: '/Dashboard/',
      component: () => import('@/components/Dashboard/List')
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js